import Vue from 'vue'
import VueRouter from 'vue-router'
import RootCategories from '../components/RootCategories'
import NoAlias from "../components/NoAlias";


Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: '/apps/new-guides',
  routes: [
    { path: '/:alias', component: RootCategories, name: 'Guides - Home page' },
    { path: '/', component: NoAlias, name: 'no-alias' },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth"
      }
    } else {
      return { x: 0, y: 0 };
    }
  }
})
